'use client';

import { AuthContext } from '@/contexts/AuthContext/AuthContext';
import { useContext } from 'react';

export const useAuth = () => useContext(AuthContext);
